import { FC, PropsWithChildren } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStaffListPath, getStaffSection } from '../../../../app/router/staffNavigation';
import { STAFF_HISTORY_ROUTE, STAFF_IDM_ROUTE, STAFF_PAYMENT_DETAILS_ROUTE, STAFF_USER_ROUTE } from "../../../../app/router/routes";
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import idmClasses from "../../../idm/ui/idm/idmWidget.module.scss";
import classes from "../staff/staffWidget.module.scss";

interface IStaffDetailLayoutProps extends PropsWithChildren {
    staffId: number | null;
    isLoading: boolean;
    loadError?: string;
    selectedTab: 1 | 2 | 3 | 4;
    showSwitch: boolean;
    showPaymentDetailsTab?: boolean;
    showHistoryTab?: boolean;
}

export const StaffDetailLayout: FC<IStaffDetailLayoutProps> = ({
    staffId,
    isLoading,
    loadError,
    selectedTab,
    showSwitch,
    showPaymentDetailsTab = false,
    showHistoryTab = false,
    children,
}) => {
    const navigate = useNavigate()
    const {pathname, search} = useLocation()

    const onSelectTab = (tab: 1 | 2 | 3 | 4) => {
        if(!staffId){
            return
        }

        const route = {
            1: STAFF_USER_ROUTE,
            2: STAFF_IDM_ROUTE,
            3: STAFF_HISTORY_ROUTE,
            4: STAFF_PAYMENT_DETAILS_ROUTE,
        }[tab]
        navigate(route.path.replace('/staff', getStaffListPath(getStaffSection(pathname))).replace(':user_id', String(staffId)) + search)
    }

    const tabsCount = 2 + (showPaymentDetailsTab ? 1 : 0) + (showHistoryTab ? 1 : 0)

    return (
        <section className={classes.detailPage}>
            <section className={idmClasses.content}>
                {isLoading
                    ? <section className={idmClasses.loader}><LoaderSpinner /></section>
                    : loadError
                        ? <section className={idmClasses.placeholder}>{loadError}</section>
                    : staffId
                        ? <>
                            {showSwitch && (
                                <section className={classes.switchWrap}>
                                    <section
                                        className={classes.detailTabs}
                                        style={{gridTemplateColumns: `repeat(${tabsCount}, minmax(0, 1fr))`}}
                                    >
                                        <button
                                            className={classes.detailTab + (selectedTab === 1 ? ` ${classes.detailTabActive}` : '')}
                                            onClick={() => onSelectTab(1)}
                                        >
                                            Личные данные
                                        </button>
                                        {showPaymentDetailsTab && (
                                            <button
                                                className={classes.detailTab + (selectedTab === 4 ? ` ${classes.detailTabActive}` : '')}
                                                onClick={() => onSelectTab(4)}
                                            >
                                                Реквизиты
                                            </button>
                                        )}
                                        <button
                                            className={classes.detailTab + (selectedTab === 2 ? ` ${classes.detailTabActive}` : '')}
                                            onClick={() => onSelectTab(2)}
                                        >
                                            Права и доступы
                                        </button>
                                        {showHistoryTab && (
                                            <button
                                                className={classes.detailTab + (selectedTab === 3 ? ` ${classes.detailTabActive}` : '')}
                                                onClick={() => onSelectTab(3)}
                                            >
                                                История изменений
                                            </button>
                                        )}
                                    </section>
                                </section>
                            )}
                            {children}
                        </>
                        : <section className={idmClasses.placeholder}>Сотрудник не выбран</section>
                }
            </section>
        </section>
    )
}
